// Loader.js

import React from 'react';
import './Loader.css'; // Import your CSS file for loader styling

const Loader = () => {
  return (
   <div className='loader-position'> 
<div class="loader"></div>
</div>
  );
};

export default Loader;
